import { render, staticRenderFns } from "./RegisterCountByTypeChart.vue?vue&type=template&id=5f883eaa&scoped=true&"
import script from "./RegisterCountByTypeChart.vue?vue&type=script&lang=js&"
export * from "./RegisterCountByTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f883eaa",
  null
  
)

export default component.exports